import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id, Map } from '../../shared/types'
import { fetchMapById } from './mapsThunks'
import { MapsState } from './types'
import { RootState } from '../../app/store'

const initialState: MapsState = {
  activeMapId: null,
  visitedMaps: {},
  loading: false,
  error: null,
}
const mapsSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    resetMaps: () => initialState,
    setActiveMapId(state, action: PayloadAction<Id>) {
      state.activeMapId = action.payload
    },
    clearMaps(state) {
      state.activeMapId = null
      state.visitedMaps = {}
      state.loading = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMapById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMapById.fulfilled, (state, action) => {
        const map = action.payload
        state.visitedMaps[map.id] = map
        state.loading = false
        state.error = null
      })
      .addCase(fetchMapById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const selectActiveMap = (state: RootState) => {
  const { activeMapId, visitedMaps } = state.maps
  return activeMapId ? (visitedMaps[activeMapId] ?? null) : null
}

export const { setActiveMapId, resetMaps, clearMaps } = mapsSlice.actions
export default mapsSlice.reducer
